<div class="main-content">
    <div class="main-heading">
        <span>{{translatekey | translate}}</span>
    </div>
    <div class="card">
        <div class="card-body">
            <div [innerHTML]="content"></div>
        </div>
    </div>
</div>